import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer } from "react-toastify";

import Loading from "./components/Loading";
import EmailValidationResult from "./components/EmailValidationResult";
import { postUserValidateEmail } from "../../../helpers/backend_helper";

const ValidateEmail = () => {
  const { id, type, token } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [isValidatedEmail, setIsValidatedEmail] = useState(false);

  const fetchValidateEmail = () => {
    const data = {
      id,
      type,
      token,
    };

    postUserValidateEmail(data)
      .then((resp) => {
        if (resp) {
          setIsValidatedEmail(true);
        }
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(fetchValidateEmail, []);

  return (
    <>
      <ToastContainer />
      {isLoading ? (
        <Loading description="Validando correo electrónico" />
      ) : (
        <EmailValidationResult isValidatedEmail={isValidatedEmail} />
      )}
    </>
  );
};

export default ValidateEmail;
